import React from 'react';
import { Icon } from './Icon.js';
export const IconFilterOff = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 3H3L3 6L10.5 13.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 20.6934L9 22.9434V19.2412L11 17.2412V20.0566L13 19.3066V15.2412L15 13.2412V20.6934Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M3 21L22 2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconFilterOff.js.map